import React, { useEffect, useRef, useState } from "react"
import ReCAPTCHA from "react-google-recaptcha"
import InputField from "../InputField"
import Checkbox from "../Checkbox"
import ButtonSubmit from "../ButtonSubmit"
import Money from "../../images/money.png"

import { onSuccess, onFail, onSendSMS } from "../../UI/PopUp"

import useForm from "../../hooks"
import { RECAPTCHA_SITE_KEY, RECAPTCHA_SIZE } from "../../helpers/recaptcha"

import "./index.scss"

const isInvisible = RECAPTCHA_SIZE === "invisible"

const Form = ({ link, product }) => {
  const recaptchaRef = useRef(null)
  const captchaTokenRef = useRef(null)
  const captchaControlsRef = useRef({
    getToken: async () => null,
    reset: () => {},
  })
  const [captchaError, setCaptchaError] = useState("")

  const resetCaptcha = () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset()
    }
    captchaTokenRef.current = null
  }

  const getCaptchaToken = async () => {
    if (isInvisible) {
      return recaptchaRef.current?.executeAsync()
    }
    return captchaTokenRef.current
  }

  captchaControlsRef.current = {
    getToken: getCaptchaToken,
    reset: resetCaptcha,
    setError: setCaptchaError,
  }

  const {
    state,
    smsContext,
    changeName,
    changePhone,
    checkedName,
    checkedInn,
    changeInn,
    checkedPhone,
    toggleRule,
    onClick,
  } = useForm(link, product, captchaControlsRef)
  const { name, inn, phone, success, fail, rule, sendSMS } = state

  useEffect(() => {
    if (sendSMS) {
      onSendSMS(phone.value, smsContext)
    }
    // Only when OTP flow is started; avoid re-opening Swal on captcha re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendSMS])

  useEffect(() => {
    if (success) {
      onSuccess()
    }
  }, [success])

  useEffect(() => {
    if (fail) {
      onFail()
    }
  }, [fail])

  return (
    <div className="order-form">
      <div className="order-form__wrapper">
        <div className="order-form__controls">
          <form
            id="form"
            onSubmit={e => {
              e.preventDefault()
              onClick()
            }}
          >
            <InputField
              title={"Ваше ім'я"}
              type={"text"}
              placeholder={"Ім'я"}
              message={"Перевірте правильність вводу імені або прізвища"}
              change={changeName}
              checked={name.checked}
              checkedFunc={checkedName}
              value={name.value}
              valid={name.valid}
              full={true}
            />
            <InputField
              title={"Номер телефону"}
              type={"phone"}
              placeholder={"Номер телефону"}
              message={"Перевірте правильність вводу номеру телефона"}
              change={changePhone}
              checked={phone.checked}
              value={phone.value}
              checkedFunc={checkedPhone}
              valid={phone.valid}
              full={true}
            />
            <InputField
              title={"ІПН"}
              type={"text"}
              placeholder={"ІПН"}
              message={"Перевірте правильність вводу ІПН"}
              change={changeInn}
              checked={inn.checked}
              checkedFunc={checkedInn}
              value={inn.value}
              valid={inn.valid}
              full={true}
            />

            <Checkbox
              onClick={toggleRule}
              checked={rule}
              message={
                "Будь ласка, підтвердіть згоду на обробку та використання даних"
              }
            />
            <div
              className={
                isInvisible ? undefined : "order-form__captcha"
              }
            >
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={RECAPTCHA_SITE_KEY}
                size={RECAPTCHA_SIZE}
                hl="uk"
                onChange={token => {
                  if (!isInvisible) {
                    captchaTokenRef.current = token
                    setCaptchaError("")
                  }
                }}
                onExpired={resetCaptcha}
                onErrored={resetCaptcha}
              />
              {captchaError ? (
                <div className="order-form__captcha-error">{captchaError}</div>
              ) : null}
            </div>
            <ButtonSubmit click={onClick} title={"Перекредитуватись!"} />
          </form>
        </div>
        <div className="order-form__image">
          <img src={Money} alt />
        </div>
      </div>
    </div>
  )
}

export default Form
